import { render } from "./RepairType.vue?vue&type=template&id=1dbc1b10&scoped=true"
import script from "./RepairType.vue?vue&type=script&lang=js"
export * from "./RepairType.vue?vue&type=script&lang=js"

import "./RepairType.vue?vue&type=style&index=0&id=1dbc1b10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dbc1b10"]])

export default __exports__